import { twMerge } from 'tailwind-merge';

interface WarningTagProps {
  text: string;
  icon: React.ReactNode;
  containerClassName?: string;
  textClassName?: string;
}

export const WarningTag = ({
  text,
  icon,
  containerClassName,
  textClassName,
}: WarningTagProps) => {
  return (
    <div
      className={twMerge(
        'flex gap-3 px-4 pt-4 pb-1.75 bg-blue-E9F1FB border border-dashed border-primary rounded max-sm:pb-2.75',
        containerClassName,
      )}
    >
      <div className="-mt-1.75">{icon}</div>
      <p
        className={twMerge(
          'text-2sm font-semibold leading-tight',
          textClassName,
        )}
      >
        {text}
      </p>
    </div>
  );
};
